import { configureStore } from "@reduxjs/toolkit";
import ProjectSlice from "../Slices/ProjectSlice";

const store = configureStore({
  reducer: {
    ProjectSlice,
  }
});

export default store;
